







































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import ajax from '@/lib/ajax';
import { OpportunityDetailsModule } from '@/store/modules/opportunityDetails';
import { CompanyListModule } from '@/store/modules/companyList';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import OpportunityStage from '@/models/Opportunities/OpportunityStage';
import ConvertOpportunityRequest, {
  NewCompanyFromOpportunity,
  NewLocationFromOpportunity,
  NewContactFromOpportunity,
  CreateJobFromOpportunity,
} from '@/models/Opportunities/ConvertOpportunityRequest';
import ConvertOpportunityResponse from '@/models/Opportunities/ConvertOpportunityResponse';
import CountryIso from '@/lib/countryIso';
import AddressUtils from '@/lib/addressUtils';
import EntityType from '@/models/Shared/EntityType';
import ComponentLocation from '@/models/Shared/ComponentLocation';
import OpenEntityInNewWindowBtn from '@/components/Shared/OpenEntityInNewWindowBtn.vue';

type CompanyMode = 'linked' | 'existing' | 'new';
type LocationMode = 'linked' | 'existing' | 'new' | 'skip';
type ContactMode = 'linked' | 'existing' | 'new' | 'skip';

@Component({ name: 'OpportunityConvert', components: { OpenEntityInNewWindowBtn } })
export default class OpportunityConvert extends GiganautVueDialog {
  // Enums exposed to the template for the duplicate-check grids.
  EntityType = EntityType;
  ComponentLocation = ComponentLocation;

  step = 1;

  companyMode: CompanyMode = 'new';
  pickedCompany: any = null;
  newCompany: NewCompanyFromOpportunity = this.blankCompany();
  // Google Places search box + country picker for the new-company address.
  companyAddressSearch = '';
  newCompanyAddressCountry: CountryIso | null = null;
  companyFormValid = true;

  locationMode: LocationMode = 'new';
  pickedLocation: any = null;
  newLocation: NewLocationFromOpportunity = this.blankLocation();
  // Country is captured via a picker (ISO-2), matching the main Location form.
  // The backend requires a 2-char country code, so a free-text field wouldn't do.
  newLocationCountry: CountryIso | null = null;
  // Google Places search box for the new-location address.
  locationAddressSearch = '';
  locationFormValid = true;

  // Server-side geocode ("Lookup coordinates") in-progress flags, one per
  // address step — mirrors the create-worker wizard.
  geocodingCompany = false;
  geocodingLocation = false;

  contactMode: ContactMode = 'new';
  pickedContact: any = null;
  newContact: NewContactFromOpportunity = this.blankContact();
  contactFormValid = true;
  linkExistingContactToLocation = true;

  wantsJob = false;
  job: CreateJobFromOpportunity & { annualSalaryMinPounds: number; annualSalaryMaxPounds: number } = this.blankJob();
  jobFormValid = true;

  submitting = false;
  submitError = '';
  result: ConvertOpportunityResponse | null = null;
  acknowledgedReconvert = false;

  // Scoped lists, refreshed when the resolved-company / resolved-location IDs
  // change (i.e. as the user picks records in earlier steps). Both feed the
  // "Match existing" autocompletes AND the inline dedup panels in the
  // "Create new" sub-forms, so we only fetch each once per scope change.
  scopedCompanyLocations: any[] = [];
  loadingScopedCompanyLocations = false;
  scopedContacts: any[] = [];
  loadingScopedContacts = false;

  // Contact picker scope: false ⇒ contacts at the resolved location;
  // true ⇒ all contacts at the resolved company. Defaults below in
  // prefill / on dialog open based on what's resolved.
  showAllCompanyContacts = false;

  // ── Duplicate search ──────────────────────────────────────────────────────
  // When creating a NEW company/location we auto-run a name-based duplicate
  // check against the existing database (rich profile lists, so we can show a
  // worker-wizard-style grid: ref / name / email / status / name-match / open),
  // same discipline as the create-worker wizard. Per entity: the results,
  // loading/searched flags, and an explicit "create new anyway" acknowledgement
  // that gates Next when non-exact matches are present.
  companyDedupResults: any[] = [];
  companyDedupLoading = false;
  companyDedupSearched = false;
  companyCreateNewConfirmed = false;
  locationDedupResults: any[] = [];
  locationDedupLoading = false;
  locationDedupSearched = false;
  locationCreateNewConfirmed = false;
  contactDedupResults: any[] = [];
  contactDedupLoading = false;
  contactDedupSearched = false;
  contactCreateNewConfirmed = false;

  // Debounce timers for the auto-running duplicate checks (one per entity).
  private companyDedupTimer: number | null = null;
  private locationDedupTimer: number | null = null;
  private contactDedupTimer: number | null = null;

  blankCompany(): NewCompanyFromOpportunity {
    return {
      brandName: '', emailAddress: '', phoneNumber: '', website: '',
      taxNumber: '', registrationNumber: '',
      address: this.blankCompanyAddress(),
    };
  }
  blankCompanyAddress(): NonNullable<NewCompanyFromOpportunity['address']> {
    return {
      type: '', building: '', street: '', locality: '',
      city: '', region: '', postcode: '', country: '',
      latitude: null, longitude: null,
    };
  }
  blankLocation(): NewLocationFromOpportunity {
    return {
      brandName: '', emailAddress: '', locationTypeId: '', rateCardId: '',
      buildingNameNumber: '', streetRoadBlock: '', locality: '',
      cityTown: '', stateProvinceRegion: '', postZipCode: '', countryCode: '',
      latitude: null, longitude: null,
    };
  }
  blankContact(): NewContactFromOpportunity {
    return { firstName: '', lastName: '', emailAddress: '', mobilePhoneNumber: '', otherPhoneNumber: '', jobTitle: '', positionId: null };
  }
  blankJob() {
    return {
      title: '', headcount: 1, primaryPositionId: '', desiredStartDate: '',
      annualSalaryMin: 0, annualSalaryMax: 0,
      annualSalaryMinPounds: 0, annualSalaryMaxPounds: 0,
    };
  }

  // ─── Getters ────────────────────────────────────────────────────────────

  get opportunity() { return OpportunityDetailsModule.opportunity; }
  get companies() { return CompanyListModule.companies; }
  get locationTypes() { return AgencySettingsModule.locationTypes; }
  get rateCards() { return AgencySettingsModule.rateCards; }
  get positions() { return AgencySettingsModule.positions; }
  get isoCountries(): CountryIso[] { return AddressUtils.isoCountries(); }

  // Resolve a free-text snapshot country ("GB", "United Kingdom", "") to an ISO
  // country object for the picker. Falls back to GB (the agency's home country).
  resolveCountry(raw: string | null): CountryIso | null {
    const list = this.isoCountries;
    const val = (raw || '').trim().toLowerCase();
    if (val) {
      const match = list.find(c => c.code.toLowerCase() === val || c.name.toLowerCase() === val);
      if (match) return match;
    }
    return list.find(c => c.code.toLowerCase() === 'gb') || null;
  }

  // Match a Google short_name (ISO-2, e.g. "GB") to an ISO country object.
  // NOTE: uses === (not the =-assignment bug copied across the app's other
  // address handlers, which ends up selecting the last country in the list).
  matchCountry(shortName: string): CountryIso | null {
    if (!shortName) return null;
    const code = shortName.toLowerCase();
    return this.isoCountries.find(c => c.code.toLowerCase() === code) || null;
  }

  // Pull the postal town (city) and country out of a Google place result — the
  // parts that aren't on the flat addressData object.
  extractPlaceParts(placeData: any): { cityTown: string; country: CountryIso | null } {
    let cityTown = '';
    let country: CountryIso | null = null;
    const components = (placeData && placeData.address_components) || [];
    for (const el of components) {
      if (el.types && el.types[0] === 'postal_town') cityTown = el.long_name;
      if (el.types && el.types[0] === 'country') country = this.matchCountry(el.short_name);
    }
    return { cityTown, country };
  }

  // Google Places → new-location address fields + coordinates + country picker.
  onLocationPlaceChanged(addressData: any, placeData: any) {
    this.newLocation.buildingNameNumber = addressData.street_number || '';
    this.newLocation.streetRoadBlock = addressData.route || '';
    this.newLocation.locality = addressData.locality || '';
    this.newLocation.stateProvinceRegion = addressData.administrative_area_level_2 || '';
    this.newLocation.postZipCode = addressData.postal_code || '';
    this.newLocation.latitude = addressData.latitude != null ? Number(addressData.latitude) : null;
    this.newLocation.longitude = addressData.longitude != null ? Number(addressData.longitude) : null;
    const { cityTown, country } = this.extractPlaceParts(placeData);
    if (cityTown) this.newLocation.cityTown = cityTown;
    if (country) this.newLocationCountry = country;
  }

  // Google Places → new-company address fields + coordinates + country picker.
  onCompanyPlaceChanged(addressData: any, placeData: any) {
    if (!this.newCompany.address) this.newCompany.address = this.blankCompanyAddress();
    const a = this.newCompany.address;
    a.building = addressData.street_number || '';
    a.street = addressData.route || '';
    a.locality = addressData.locality || '';
    a.region = addressData.administrative_area_level_2 || '';
    a.postcode = addressData.postal_code || '';
    a.latitude = addressData.latitude != null ? Number(addressData.latitude) : null;
    a.longitude = addressData.longitude != null ? Number(addressData.longitude) : null;
    const { cityTown, country } = this.extractPlaceParts(placeData);
    if (cityTown) a.city = cityTown;
    if (country) this.newCompanyAddressCountry = country;
  }

  // Map state for the new-location address (worker-wizard style).
  get hasLocationCoordinates(): boolean {
    return this.newLocation.latitude != null && this.newLocation.longitude != null
      && (Number(this.newLocation.latitude) !== 0 || Number(this.newLocation.longitude) !== 0);
  }
  get locationMapCenter() {
    return { lat: Number(this.newLocation.latitude) || 0, lng: Number(this.newLocation.longitude) || 0 };
  }

  // Map state for the new-company address (worker-wizard style).
  get hasCompanyCoordinates(): boolean {
    const a = this.newCompany.address;
    return !!a && a.latitude != null && a.longitude != null
      && (Number(a.latitude) !== 0 || Number(a.longitude) !== 0);
  }
  get companyMapCenter() {
    const a = this.newCompany.address;
    return { lat: Number(a && a.latitude) || 0, lng: Number(a && a.longitude) || 0 };
  }

  // Enough address entered to attempt a server-side geocode lookup.
  get hasCompanyAddressData(): boolean {
    const a = this.newCompany.address;
    return !!a && !!(a.building || a.street || a.locality || a.city || a.region || a.postcode);
  }
  get hasLocationAddressData(): boolean {
    const l = this.newLocation;
    return !!(l.buildingNameNumber || l.streetRoadBlock || l.locality || l.cityTown || l.stateProvinceRegion || l.postZipCode);
  }

  // Geocode the typed address to coordinates via the shared endpoint (same one
  // the create-worker wizard uses). Lets the user drop a pin without picking
  // from Google autocomplete.
  async lookupCompanyCoordinates() {
    const a = this.newCompany.address;
    if (!a || !this.hasCompanyAddressData) return;
    this.geocodingCompany = true;
    try {
      const params = new URLSearchParams();
      if (a.building) params.append('buildingNameNumber', a.building);
      if (a.street) params.append('streetRoadBlock', a.street);
      if (a.locality) params.append('locality', a.locality);
      if (a.city) params.append('cityTown', a.city);
      if (a.region) params.append('stateProvinceRegion', a.region);
      if (a.postcode) params.append('postZipCode', a.postcode);
      if (this.newCompanyAddressCountry) params.append('countryCode', this.newCompanyAddressCountry.code);
      const r = await ajax.get(`/api/v1/agency/address/lookup-geo?${params.toString()}`);
      a.latitude = r.data.lat;
      a.longitude = r.data.lng;
    } catch (e) {
      console.error('Geocoding error:', e);
    } finally {
      this.geocodingCompany = false;
    }
  }

  async lookupLocationCoordinates() {
    const l = this.newLocation;
    if (!this.hasLocationAddressData) return;
    this.geocodingLocation = true;
    try {
      const params = new URLSearchParams();
      if (l.buildingNameNumber) params.append('buildingNameNumber', l.buildingNameNumber);
      if (l.streetRoadBlock) params.append('streetRoadBlock', l.streetRoadBlock);
      if (l.locality) params.append('locality', l.locality);
      if (l.cityTown) params.append('cityTown', l.cityTown);
      if (l.stateProvinceRegion) params.append('stateProvinceRegion', l.stateProvinceRegion);
      if (l.postZipCode) params.append('postZipCode', l.postZipCode);
      if (this.newLocationCountry) params.append('countryCode', this.newLocationCountry.code);
      const r = await ajax.get(`/api/v1/agency/address/lookup-geo?${params.toString()}`);
      l.latitude = r.data.lat;
      l.longitude = r.data.lng;
    } catch (e) {
      console.error('Geocoding error:', e);
    } finally {
      this.geocodingLocation = false;
    }
  }

  // The ID of the company the wizard will actually convert to — driven by
  // Step 1's choice. Null when creating a brand-new company, since the
  // company-side dependents (locations, contacts) don't have a parent to
  // scope against yet. The Step 2 / Step 3 pickers gate on this and the
  // location dedup panel filters against this company's existing locations.
  get resolvedCompanyId(): string | null {
    if (this.companyMode === 'linked' && this.opportunity && this.opportunity.companyId) return this.opportunity.companyId;
    if (this.companyMode === 'existing' && this.pickedCompany) return this.pickedCompany.id;
    return null;
  }

  get resolvedCompanyDisplayName(): string {
    if (this.companyMode === 'linked' && this.opportunity?.company) return this.opportunity.company.brandName || '';
    if (this.companyMode === 'existing' && this.pickedCompany) return this.pickedCompany.brandName || '';
    return '';
  }

  get resolvedLocationId(): string | null {
    if (this.locationMode === 'linked' && this.opportunity && this.opportunity.locationId) return this.opportunity.locationId;
    if (this.locationMode === 'existing' && this.pickedLocation) return this.pickedLocation.id;
    return null;
  }

  // Contact picker label — describes which list the autocomplete is showing.
  get contactScopeLabel(): string {
    if (this.resolvedLocationId && !this.showAllCompanyContacts) {
      const ln = this.opportunity?.location?.brandName || this.pickedLocation?.brandName || '';
      return ln ? `at ${ln}` : 'at this location';
    }
    if (this.resolvedCompanyId) {
      return this.resolvedCompanyDisplayName ? `at ${this.resolvedCompanyDisplayName}` : 'at this company';
    }
    return '';
  }

  // ── Duplicate check against the existing database ─────────────────────────
  // Dedicated per-entity endpoints (mirroring /workers/check-duplicates) do the
  // matching server-side and return rich rows for the grid. Companies/locations
  // match on name only; contacts on name + email. Runs automatically — no
  // Search button — and re-runs debounced as the name is edited.
  async runCompanyDedup() {
    const name = (this.newCompany.brandName || '').trim();
    this.companyCreateNewConfirmed = false;
    if (name.length < 2) { this.companyDedupResults = []; this.companyDedupSearched = false; return; }
    this.companyDedupLoading = true;
    try {
      const r = await ajax.post('/api/v1/agency/companies/check-duplicates', { name });
      this.companyDedupResults = (r.data && r.data.matches) || [];
      this.companyDedupSearched = true;
    } catch {
      this.companyDedupResults = [];
      this.companyDedupSearched = true;
    } finally {
      this.companyDedupLoading = false;
    }
  }

  async runLocationDedup() {
    const name = (this.newLocation.brandName || '').trim();
    this.locationCreateNewConfirmed = false;
    if (name.length < 2) { this.locationDedupResults = []; this.locationDedupSearched = false; return; }
    this.locationDedupLoading = true;
    try {
      const r = await ajax.post('/api/v1/agency/locations/check-duplicates', { name });
      this.locationDedupResults = (r.data && r.data.matches) || [];
      this.locationDedupSearched = true;
    } catch {
      this.locationDedupResults = [];
      this.locationDedupSearched = true;
    } finally {
      this.locationDedupLoading = false;
    }
  }

  async runContactDedup() {
    const first = (this.newContact.firstName || '').trim();
    const last = (this.newContact.lastName || '').trim();
    const email = (this.newContact.emailAddress || '').trim();
    this.contactCreateNewConfirmed = false;
    if (!first && !last && !email) { this.contactDedupResults = []; this.contactDedupSearched = false; return; }
    this.contactDedupLoading = true;
    try {
      const r = await ajax.post('/api/v1/agency/contacts/check-duplicates', { firstName: first, lastName: last, emailAddress: email });
      this.contactDedupResults = (r.data && r.data.matches) || [];
      this.contactDedupSearched = true;
    } catch {
      this.contactDedupResults = [];
      this.contactDedupSearched = true;
    } finally {
      this.contactDedupLoading = false;
    }
  }

  // A company/location profile's display name (brand preferred, else registered).
  profileName(r: any): string {
    return (r && (r.brandName || r.registeredName)) || '';
  }

  // Editing the name re-runs the check automatically (debounced) — no button.
  onCompanyNameChanged() {
    this.companyDedupSearched = false;
    this.companyCreateNewConfirmed = false;
    if (this.companyDedupTimer) clearTimeout(this.companyDedupTimer);
    this.companyDedupTimer = window.setTimeout(() => this.runCompanyDedup(), 400);
  }
  onLocationNameChanged() {
    this.locationDedupSearched = false;
    this.locationCreateNewConfirmed = false;
    if (this.locationDedupTimer) clearTimeout(this.locationDedupTimer);
    this.locationDedupTimer = window.setTimeout(() => this.runLocationDedup(), 400);
  }
  onContactNameChanged() {
    this.contactDedupSearched = false;
    this.contactCreateNewConfirmed = false;
    if (this.contactDedupTimer) clearTimeout(this.contactDedupTimer);
    this.contactDedupTimer = window.setTimeout(() => this.runContactDedup(), 400);
  }

  // Picking a search result links the existing record (mode → 'existing').
  // Changing the company invalidates any venue/contact chosen under the old
  // one, so cascade a reset of the later steps to avoid a mixed-up state.
  pickCompanyMatch(r: any) { this.pickedCompany = { id: r.id, brandName: this.profileName(r) }; this.companyMode = 'existing'; this.resetDownstreamOfCompany(); }
  pickLocationMatch(r: any) { this.pickedLocation = { id: r.id, brandName: this.profileName(r) }; this.locationMode = 'existing'; }
  pickContactMatch(r: any) { this.pickedContact = { id: r.id, name: r.fullName }; this.contactMode = 'existing'; }

  // Venue and contact belong to whichever client is resolved, so whenever the
  // client changes we clear them (selection, mode, dedup state) back to their
  // defaults. Prevents e.g. keeping "33 The Scullery — Bar" as the venue after
  // switching the client to a different company.
  resetDownstreamOfCompany() {
    this.pickedLocation = null;
    this.locationMode = this.canReuseLinkedLocation ? 'linked' : 'new';
    this.locationDedupResults = [];
    this.locationDedupSearched = false;
    this.locationCreateNewConfirmed = false;
    this.pickedContact = null;
    this.contactMode = 'new';
    this.contactDedupResults = [];
    this.contactDedupSearched = false;
    this.contactCreateNewConfirmed = false;
    this.linkExistingContactToLocation = true;
  }

  // Status → { text, colour } for the grid chip (statuses per CLAUDE.md).
  statusDisplay(status: number): { text: string; color: string } {
    switch (status) {
      case 90: return { text: 'Active', color: 'success' };
      case 91: return { text: 'Locked', color: 'warning' };
      case 10: return { text: 'Failed', color: 'error' };
      case 100: return { text: 'Deleted', color: 'grey' };
      default: return { text: '—', color: 'grey' };
    }
  }

  // Undo a pick / go back to creating a new record (keeps the entered details).
  unpickCompany() { this.pickedCompany = null; this.companyMode = 'new'; this.resetDownstreamOfCompany(); this.runCompanyDedup(); }
  unpickLocation() { this.pickedLocation = null; this.locationMode = 'new'; this.runLocationDedup(); }
  unpickContact() { this.pickedContact = null; this.contactMode = 'new'; this.runContactDedup(); }

  // A strong match — an exact-name (company/location) or email (contact)
  // duplicate. It's flagged prominently as a warning, but never a hard lock:
  // the user can still create a new record (or pick a different one) by
  // acknowledging the "create new anyway" toggle. Flags come from the backend.
  get companyStrongMatch(): any | null {
    return this.companyDedupResults.find(r => r.nameMatch) || null;
  }
  get locationStrongMatch(): any | null {
    return this.locationDedupResults.find(r => r.nameMatch) || null;
  }
  get contactStrongMatch(): any | null {
    return this.contactDedupResults.find(r => r.emailMatch) || null;
  }

  // The dedup gate for a "create new" step: must have searched; and when any
  // matches exist (strong or not), the user must acknowledge "create new
  // anyway" before proceeding — but they can always acknowledge, so it never
  // traps them. No matches → free to create.
  dedupResolved(searched: boolean, results: any[], strong: any | null, confirmed: boolean): boolean {
    if (!searched) return false;
    if (results.length > 0 && !confirmed) return false;
    return true;
  }

  // The remaining "create new" fields (address, position, etc.) only appear
  // once the name-based duplicate check is clear — name-first flow.
  get showCompanyRemainingFields(): boolean {
    return this.companyMode === 'new'
      && this.dedupResolved(this.companyDedupSearched, this.companyDedupResults, this.companyStrongMatch, this.companyCreateNewConfirmed);
  }
  get showLocationRemainingFields(): boolean {
    return this.locationMode === 'new'
      && this.dedupResolved(this.locationDedupSearched, this.locationDedupResults, this.locationStrongMatch, this.locationCreateNewConfirmed);
  }
  get showContactRemainingFields(): boolean {
    return this.contactMode === 'new'
      && this.dedupResolved(this.contactDedupSearched, this.contactDedupResults, this.contactStrongMatch, this.contactCreateNewConfirmed);
  }

  // Scoped-list fetchers — single source of truth for both the autocomplete
  // pickers and the dedup panels. Direct ajax rather than touching
  // CompanyDetailsModule/LocationDetailsModule so we don't disturb their
  // currentCompany/currentLocation state used elsewhere in the app.
  async refreshScopedCompanyLocations() {
    const id = this.resolvedCompanyId;
    if (!id) {
      this.scopedCompanyLocations = [];
      return;
    }
    this.loadingScopedCompanyLocations = true;
    try {
      const r = await ajax.get(`/api/v1/agency/companies/${id}/locations`);
      this.scopedCompanyLocations = r.data || [];
    } finally {
      this.loadingScopedCompanyLocations = false;
    }
  }

  async refreshScopedContacts() {
    const useLocation = !!this.resolvedLocationId && !this.showAllCompanyContacts;
    const url = useLocation
      ? `/api/v1/agency/locations/${this.resolvedLocationId}/contacts`
      : (this.resolvedCompanyId ? `/api/v1/agency/companies/${this.resolvedCompanyId}/contacts` : null);
    if (!url) {
      this.scopedContacts = [];
      return;
    }
    this.loadingScopedContacts = true;
    try {
      const r = await ajax.get(url);
      const rows = r.data || [];
      // /locations/{id}/contacts returns ContactLocation rows with .contact
      // nested; /companies/{id}/contacts returns Contact rows directly.
      this.scopedContacts = useLocation
        ? rows.map((cl: any) => cl.contact).filter(Boolean)
        : rows;
    } finally {
      this.loadingScopedContacts = false;
    }
  }

  get isPerm(): boolean {
    return !!this.opportunity && this.opportunity.workTypes.indexOf('Perm') !== -1;
  }

  // Steps: 1 Company, 2 Company address, 3 Location, 4 Location address,
  // 5 Contact, 6 Job (Perm only), then Review. Job step is conditional.
  get reviewStep(): number {
    return this.isPerm ? 7 : 6;
  }

  // Formatted address lines for the linked location, shown on the location
  // address step when we're reusing an existing record (nothing to capture).
  get linkedLocationAddressLines(): string[] {
    const l = this.opportunity && this.opportunity.location;
    if (!l) return [];
    const line1 = [l.buildingNameNumber, l.streetRoadBlock].filter(Boolean).join(' ');
    const line2 = [l.cityTown, l.stateProvinceRegion, l.postZipCode].filter(Boolean).join(', ');
    return [line1, line2, l.countryCode].filter((s: string) => !!s && s.trim());
  }

  get hasLinkedCompany(): boolean {
    return !!this.opportunity && !!this.opportunity.companyId && !!this.opportunity.company;
  }

  // Linked location is only reusable if it sits under the company we'll end up
  // resolving in Step 1 (linked-company path). For "pick existing company" or
  // "create new company" paths, the previously-linked location may belong to
  // a different company entirely, so we hide the option.
  get canReuseLinkedLocation(): boolean {
    if (!this.opportunity || !this.opportunity.locationId || !this.opportunity.location) return false;
    if (this.companyMode !== 'linked') return false;
    return true;
  }

  get hasLinkedContact(): boolean {
    return !!this.opportunity && !!this.opportunity.contactId && !!this.opportunity.contact;
  }

  // When the company is brand-new, the previously-linked location can't be reused.
  get resolvedCompanyIsNew(): boolean {
    return this.companyMode === 'new' || this.companyMode === 'existing';
  }

  // Skip allowed when the Job step won't need a location/contact.
  get canSkipLocation(): boolean {
    return !this.wantsJob;
  }
  get canSkipContact(): boolean {
    return !this.wantsJob;
  }

  // Drives the Add-a-venue / Skip radio toggle so skipping is never a terminal
  // decision — flip back to "add" and the create/link form returns, restoring
  // whatever was previously picked.
  get locationIncluded(): boolean {
    return this.locationMode !== 'skip';
  }
  set locationIncluded(v: boolean) {
    if (!v) {
      this.locationMode = 'skip';
      return;
    }
    if (this.pickedLocation) this.locationMode = 'existing';
    else if (this.canReuseLinkedLocation) this.locationMode = 'linked';
    else this.locationMode = 'new';
  }

  // Same reversible Add-a-contact / Skip toggle as the venue step.
  get contactIncluded(): boolean {
    return this.contactMode !== 'skip';
  }
  set contactIncluded(v: boolean) {
    if (!v) {
      this.contactMode = 'skip';
      return;
    }
    if (this.pickedContact) this.contactMode = 'existing';
    else if (this.hasLinkedContact) this.contactMode = 'linked';
    else this.contactMode = 'new';
  }

  get linkedContactName(): string {
    if (!this.opportunity || !this.opportunity.contact || !this.opportunity.contact.person) return '';
    const p = this.opportunity.contact.person;
    return `${p.firstName} ${p.lastName}`;
  }

  contactLabel(item: any): string {
    return item && item.person ? `${item.person.firstName} ${item.person.lastName}` : '';
  }

  // Show the link-contact-to-location checkbox when the contact is existing
  // (linked or picked) AND we'll have a resolved location to link it to.
  get showLinkToLocationCheckbox(): boolean {
    if (this.contactMode !== 'linked' && this.contactMode !== 'existing') return false;
    return this.locationMode !== 'skip';
  }

  get resolvedLocationDisplayHint(): string {
    if (this.locationMode === 'linked' && this.opportunity?.location) return this.opportunity.location.brandName;
    if (this.locationMode === 'existing' && this.pickedLocation) return this.pickedLocation.brandName;
    if (this.locationMode === 'new' && this.newLocation.brandName) return this.newLocation.brandName;
    return 'the resolved location';
  }

  // Hard preconditions for the Job step — surfaced as an inline error so the
  // user doesn't get a 400 at submit time.
  get jobMissingDependencies(): string {
    if (!this.opportunity) return '';
    if (!this.opportunity.branchId || !this.opportunity.deskId) {
      return 'Cannot create a Job: the opportunity has no branch or desk set. Add them on the General Details panel first, then re-open Convert.';
    }
    if (this.locationMode === 'skip') {
      return 'Cannot create a Job: a Location is required. Go back to the Location step and pick or create one.';
    }
    if (this.contactMode === 'skip') {
      return 'Cannot create a Job: a Contact is required. Go back to the Contact step and pick or create one.';
    }
    return '';
  }

  get needsReconvertConfirm(): boolean {
    return !!this.opportunity && !!this.opportunity.convertedAt && !this.acknowledgedReconvert;
  }

  // ─── Advance gates ──────────────────────────────────────────────────────

  get canAdvance(): boolean {
    if (this.step === 1) {
      if (this.companyMode === 'linked') return this.hasLinkedCompany;
      if (this.companyMode === 'existing') return !!this.pickedCompany;
      if (this.companyMode === 'new') {
        return !!this.newCompany.brandName
          && this.dedupResolved(this.companyDedupSearched, this.companyDedupResults, this.companyStrongMatch, this.companyCreateNewConfirmed);
      }
      return false;
    }
    // Company address (step 2) is optional whether the company is new or
    // existing — nothing to gate on.
    if (this.step === 2) return true;
    if (this.step === 3) {
      if (this.locationMode === 'linked') return this.canReuseLinkedLocation;
      if (this.locationMode === 'existing') return !!this.pickedLocation;
      if (this.locationMode === 'new') {
        return !!this.newLocation.brandName && !!this.newLocation.locationTypeId && !!this.newLocation.rateCardId
          && this.dedupResolved(this.locationDedupSearched, this.locationDedupResults, this.locationStrongMatch, this.locationCreateNewConfirmed);
      }
      if (this.locationMode === 'skip') return this.canSkipLocation;
      return false;
    }
    // Location address (step 4) — mandatory only when creating a new location.
    if (this.step === 4) {
      if (this.locationMode === 'new') {
        return !!this.newLocation.buildingNameNumber && !!this.newLocation.postZipCode && !!this.newLocationCountry;
      }
      return true;
    }
    if (this.step === 5) {
      if (this.contactMode === 'linked') return this.hasLinkedContact;
      if (this.contactMode === 'existing') return !!this.pickedContact;
      if (this.contactMode === 'new') {
        return !!this.newContact.firstName && !!this.newContact.lastName
          && this.dedupResolved(this.contactDedupSearched, this.contactDedupResults, this.contactStrongMatch, this.contactCreateNewConfirmed);
      }
      if (this.contactMode === 'skip') return this.canSkipContact;
      return false;
    }
    if (this.step === 6 && this.isPerm) {
      if (!this.wantsJob) return true;
      if (this.jobMissingDependencies) return false;
      return !!this.job.title && !!this.job.primaryPositionId && !!this.job.desiredStartDate && this.job.headcount >= 1;
    }
    return true;
  }

  // ─── Review text ────────────────────────────────────────────────────────

  get companyReviewText(): string {
    if (this.companyMode === 'linked') return `Reuse linked: ${this.opportunity?.company?.brandName ?? ''}`;
    if (this.companyMode === 'existing') return `Reuse existing: ${this.pickedCompany?.brandName ?? ''}`;
    return `Create new: ${this.newCompany.brandName}`;
  }
  get locationReviewText(): string {
    if (this.locationMode === 'linked') return `Reuse linked: ${this.opportunity?.location?.brandName ?? ''}`;
    if (this.locationMode === 'existing') return `Reuse existing: ${this.pickedLocation?.brandName ?? ''}`;
    if (this.locationMode === 'new') return `Create new: ${this.newLocation.brandName}`;
    return 'Skipped — add later';
  }
  get contactReviewText(): string {
    let line = '';
    if (this.contactMode === 'linked') line = `Reuse linked: ${this.linkedContactName}`;
    else if (this.contactMode === 'existing') line = `Reuse existing: ${this.pickedContact?.name ?? ''}`;
    else if (this.contactMode === 'new') line = `Create new: ${this.newContact.firstName} ${this.newContact.lastName}`;
    else line = 'Skipped — add later';
    if (this.showLinkToLocationCheckbox && this.linkExistingContactToLocation) {
      line += `; also link to ${this.resolvedLocationDisplayHint}`;
    }
    return line;
  }
  get jobReviewText(): string {
    if (!this.isPerm) return '';
    if (!this.wantsJob) return 'Not creating a Job now';
    return `Create Job: ${this.job.title} (${this.job.headcount} headcount, start ${this.job.desiredStartDate})`;
  }

  // ─── Names used on the success panel ────────────────────────────────────

  get resolvedCompanyName(): string {
    if (this.companyMode === 'linked') return this.opportunity?.company?.brandName ?? '';
    if (this.companyMode === 'existing') return this.pickedCompany?.brandName ?? '';
    return this.newCompany.brandName;
  }
  get resolvedLocationName(): string {
    if (this.locationMode === 'linked') return this.opportunity?.location?.brandName ?? '';
    if (this.locationMode === 'existing') return this.pickedLocation?.brandName ?? '';
    if (this.locationMode === 'new') return this.newLocation.brandName;
    return '';
  }
  get resolvedContactName(): string {
    if (this.contactMode === 'linked') return this.linkedContactName;
    if (this.contactMode === 'existing') return this.contactLabel(this.pickedContact);
    if (this.contactMode === 'new') return `${this.newContact.firstName} ${this.newContact.lastName}`;
    return '';
  }

  formatDate(iso: string | null): string {
    if (!iso) return '';
    try { return new Date(iso).toLocaleDateString(); } catch { return iso; }
  }

  // ─── Dialog lifecycle ───────────────────────────────────────────────────

  // The wizard is mounted only while visible (v-if in the detail view), so we
  // initialise on create rather than on a dialog-open watcher.
  async created() {
    this.reset();
    this.prefillFromOpportunity();
    // Background-load the lookups + scoped lists the wizard needs. The company
    // list is agency-wide (picker scope in Step 1 + the company-dedup source);
    // location/contact lists are fetched on demand per resolved id.
    if (this.companies.length === 0) CompanyListModule.searchCompanies();
    if (this.locationTypes.length === 0) AgencySettingsModule.getLocationTypes();
    if (this.rateCards.length === 0) AgencySettingsModule.getRateCards();
    if (this.positions.length === 0) AgencySettingsModule.getPositions();
    await this.refreshScopedCompanyLocations();
    await this.refreshScopedContacts();
    // Step 1 (Company) is visible immediately — kick off its duplicate check
    // so the grid is ready without the user doing anything.
    if (this.companyMode === 'new') this.runCompanyDedup();
  }

  // When the company choice changes, anything dependent on it (linked
  // location, picked location) becomes stale. Also re-fetches the scoped
  // location list — the new resolvedCompanyId may belong to a different
  // company so the previously-loaded locations are no longer relevant.
  @Watch('companyMode')
  onCompanyModeChanged() {
    if (this.locationMode === 'linked' && !this.canReuseLinkedLocation) {
      this.locationMode = 'new';
    }
    this.pickedLocation = null;
  }

  // Re-fetch scoped lists whenever the resolved IDs change. Tracking these
  // via computed-watcher avoids having to remember to refresh in every
  // spot where companyMode/pickedCompany/locationMode/pickedLocation could
  // be reassigned (incl. the useDuplicateAsCompany / useDuplicateAsLocation
  // shortcuts called from the dedup panels).
  @Watch('resolvedCompanyId')
  async onResolvedCompanyChanged() {
    await this.refreshScopedCompanyLocations();
    await this.refreshScopedContacts();
  }

  @Watch('resolvedLocationId')
  async onResolvedLocationChanged() {
    await this.refreshScopedContacts();
  }

  @Watch('showAllCompanyContacts')
  async onContactScopeToggled() {
    await this.refreshScopedContacts();
  }

  // Auto-run the duplicate check when landing on a step in "create new" mode,
  // so the grid is already populated — no Search button to press.
  @Watch('step')
  onStepChanged(s: number) {
    if (s === 1 && this.companyMode === 'new' && !this.companyDedupSearched) this.runCompanyDedup();
    if (s === 3 && this.locationMode === 'new' && !this.locationDedupSearched) this.runLocationDedup();
    if (s === 5 && this.contactMode === 'new' && !this.contactDedupSearched) this.runContactDedup();
  }

  // If the user enables Job creation, location and contact can no longer be
  // skipped — flip them back to a non-skip default.
  @Watch('wantsJob')
  onWantsJobChanged(v: boolean) {
    if (!v) return;
    if (this.locationMode === 'skip') this.locationMode = this.canReuseLinkedLocation ? 'linked' : 'new';
    if (this.contactMode === 'skip') this.contactMode = this.hasLinkedContact ? 'linked' : 'new';
  }

  beforeDestroy() {
    if (this.companyDedupTimer) clearTimeout(this.companyDedupTimer);
    if (this.locationDedupTimer) clearTimeout(this.locationDedupTimer);
    if (this.contactDedupTimer) clearTimeout(this.contactDedupTimer);
  }

  // Cancel: bail out of the wizard — the parent re-shows the detail tabs.
  // Guarded so an in-flight submit can't be interrupted.
  close() {
    if (this.submitting) return;
    this.$emit('cancel');
  }

  // Done: convert succeeded; the parent re-shows the tabs (now converted).
  done() {
    this.$emit('done');
  }

  reset() {
    this.step = 1;
    this.companyMode = 'new';
    this.pickedCompany = null;
    this.newCompany = this.blankCompany();
    this.newCompanyAddressCountry = null;
    this.companyAddressSearch = '';
    this.locationAddressSearch = '';
    this.locationMode = 'new';
    this.pickedLocation = null;
    this.newLocation = this.blankLocation();
    this.newLocationCountry = null;
    this.contactMode = 'new';
    this.pickedContact = null;
    this.newContact = this.blankContact();
    this.linkExistingContactToLocation = true;
    this.showAllCompanyContacts = false;
    this.scopedCompanyLocations = [];
    this.scopedContacts = [];
    this.wantsJob = false;
    this.job = this.blankJob();
    this.submitting = false;
    this.submitError = '';
    this.result = null;
    this.acknowledgedReconvert = false;
    this.companyDedupResults = []; this.companyDedupLoading = false; this.companyDedupSearched = false; this.companyCreateNewConfirmed = false;
    this.locationDedupResults = []; this.locationDedupLoading = false; this.locationDedupSearched = false; this.locationCreateNewConfirmed = false;
    this.contactDedupResults = []; this.contactDedupLoading = false; this.contactDedupSearched = false; this.contactCreateNewConfirmed = false;
  }

  prefillFromOpportunity() {
    const o = this.opportunity;
    if (!o) return;
    // Defaults: prefer reusing linked records when available, else create new.
    if (o.companyId && o.company) this.companyMode = 'linked'; else this.companyMode = 'new';
    if (this.canReuseLinkedLocation) this.locationMode = 'linked'; else this.locationMode = 'new';
    if (o.contactId && o.contact) this.contactMode = 'linked'; else this.contactMode = 'new';
    // Default contact-picker scope: prefer location-scope when a location is
    // already linked (most relevant list); else fall back to company-wide.
    this.showAllCompanyContacts = !o.locationId;

    // Seed "new" forms from snapshot fields.
    this.newCompany.brandName = o.prospectCompanyName;
    this.newCompany.emailAddress = o.prospectCompanyEmail;
    this.newCompany.phoneNumber = o.prospectCompanyPhone;
    this.newCompany.website = o.prospectCompanyWebsite;
    this.newCompany.taxNumber = o.prospectCompanyTaxNumber;
    this.newCompany.registrationNumber = o.prospectCompanyRegistrationNumber;
    // Seed the company address from the snapshot when there's anything to
    // carry across — otherwise leave it null (no address created on Convert).
    if (
      o.prospectCompanyAddressBuilding || o.prospectCompanyAddressStreet
      || o.prospectCompanyAddressCity || o.prospectCompanyAddressPostcode
      || o.prospectCompanyAddressCountry
    ) {
      this.newCompany.address = {
        type: o.prospectCompanyAddressType || '',
        building: o.prospectCompanyAddressBuilding,
        street: o.prospectCompanyAddressStreet,
        locality: o.prospectCompanyAddressLocality,
        city: o.prospectCompanyAddressCity,
        region: o.prospectCompanyAddressRegion,
        postcode: o.prospectCompanyAddressPostcode,
        country: o.prospectCompanyAddressCountry,
        latitude: o.prospectCompanyAddressLatitude,
        longitude: o.prospectCompanyAddressLongitude,
      };
      this.newCompanyAddressCountry = this.resolveCountry(o.prospectCompanyAddressCountry);
    }

    this.newLocation.brandName = o.prospectLocationName;
    this.newLocation.emailAddress = o.prospectLocationEmail;
    this.newLocation.buildingNameNumber = o.prospectLocationAddress1;
    this.newLocation.streetRoadBlock = o.prospectLocationAddress2;
    this.newLocation.locality = o.prospectLocationLocality;
    this.newLocation.cityTown = o.prospectLocationCity;
    this.newLocation.stateProvinceRegion = o.prospectLocationRegion;
    this.newLocation.postZipCode = o.prospectLocationPostcode;
    this.newLocationCountry = this.resolveCountry(o.prospectLocationCountry);
    this.newLocation.latitude = o.prospectLocationLatitude;
    this.newLocation.longitude = o.prospectLocationLongitude;
    // Pre-pick the LocationType from the snapshot. Falls through to picker if null.
    if (o.prospectLocationTypeId) {
      this.newLocation.locationTypeId = o.prospectLocationTypeId;
    }

    this.newContact.firstName = o.prospectContactFirstName;
    this.newContact.lastName = o.prospectContactLastName;
    this.newContact.emailAddress = o.prospectContactEmail;
    this.newContact.mobilePhoneNumber = o.prospectContactMobilePhoneNumber;
    this.newContact.otherPhoneNumber = o.prospectContactOtherPhoneNumber;
    this.newContact.jobTitle = o.prospectContactJobTitle;
    this.newContact.positionId = o.prospectContactPositionId;

    // Default the Job title to the opportunity name so users with a perm deal
    // don't have to re-type it.
    this.job.title = o.name.substring(0, 50);
  }

  // ─── Navigation ─────────────────────────────────────────────────────────

  next() {
    if (!this.canAdvance) return;
    // Job step (6) only exists when isPerm is true — skip straight from the
    // Contact step (5) to Review otherwise.
    if (this.step === 5 && !this.isPerm) {
      this.step = this.reviewStep;
      return;
    }
    this.step += 1;
  }

  back() {
    if (this.step === this.reviewStep && !this.isPerm) {
      this.step = 5;
      return;
    }
    if (this.step > 1) this.step -= 1;
  }

  // ─── Submit ─────────────────────────────────────────────────────────────

  async submit() {
    if (!this.opportunity) return;
    this.submitError = '';
    this.submitting = true;
    try {
      // Map the country pickers to the 2-char ISO codes the backend requires.
      if (this.locationMode === 'new') {
        this.newLocation.countryCode = this.newLocationCountry ? this.newLocationCountry.code : '';
      }
      if (this.companyMode === 'new' && this.newCompany.address) {
        this.newCompany.address.country = this.newCompanyAddressCountry ? this.newCompanyAddressCountry.code : '';
      }
      const request: ConvertOpportunityRequest = {
        updatedAt: this.opportunity.updatedAt,
        useExistingCompanyId: this.companyMode === 'existing' ? this.pickedCompany.id
          : this.companyMode === 'linked' ? this.opportunity.companyId
          : null,
        newCompanyOverrides: this.companyMode === 'new' ? this.newCompany : null,
        useExistingLocationId: this.locationMode === 'existing' ? this.pickedLocation.id
          : this.locationMode === 'linked' ? this.opportunity.locationId
          : null,
        newLocationOverrides: this.locationMode === 'new' ? this.newLocation : null,
        useExistingContactId: this.contactMode === 'existing' ? this.pickedContact.id
          : this.contactMode === 'linked' ? this.opportunity.contactId
          : null,
        newContactOverrides: this.contactMode === 'new' ? this.newContact : null,
        linkExistingContactToLocation: this.showLinkToLocationCheckbox && this.linkExistingContactToLocation,
        createJob: this.isPerm && this.wantsJob ? {
          title: this.job.title,
          headcount: this.job.headcount,
          primaryPositionId: this.job.primaryPositionId,
          desiredStartDate: this.job.desiredStartDate,
          annualSalaryMin: Math.round((this.job.annualSalaryMinPounds || 0) * 100),
          annualSalaryMax: Math.round((this.job.annualSalaryMaxPounds || 0) * 100),
        } : null,
      };

      const response = await OpportunityDetailsModule.convert({ id: this.opportunity.id, request });
      if (response) {
        this.result = response;
      } else {
        // AppModule already showed the error via the global alert handler;
        // surface a generic message in-dialog so the user can retry.
        this.submitError = 'Convert failed. See the alert at the top of the page.';
      }
    } finally {
      this.submitting = false;
    }
  }
}
